// dependency-graph-ignore-file
import { addEntryBelowMenuItem } from '../items/add-entry-below-menu-item';
import { addFieldRightMenuItem } from '../items/add-field-right-menu-item';
import { askRovoMenuItem } from '../items/ask-rovo-menu-item';
import { clearValuesMenuItem } from '../items/clear-values-menu-item';
import { commentsMenuItem } from '../items/comments-menu-item';
import { copyValueLinkMenuItem } from '../items/copy-value-link-menu-item';
import {
  type MergedActionsAPI,
  type SelectionsEffectCellContextMenuContext,
  type MenuContentItemFactory,
} from '../types';

const skip = () => null;

export function createSelectValueContextMenuItems(
  context: SelectionsEffectCellContextMenuContext,
  actions: MergedActionsAPI
): MenuContentItemFactory[] {
  return [
    askRovoMenuItem(context, actions, skip),
    { type: 'separator' },
    commentsMenuItem(context, actions, skip),
    copyValueLinkMenuItem(context, actions, skip),
    { type: 'separator' },
    addFieldRightMenuItem(context, actions, skip),
    addEntryBelowMenuItem(context, actions, skip),
    clearValuesMenuItem(context, actions, skip),
  ];
}
